import { render, staticRenderFns } from "./MenuItemCustom.vue?vue&type=template&id=b06d7150&"
import script from "./MenuItemCustom.vue?vue&type=script&lang=js&"
export * from "./MenuItemCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports